import type {SingleSimulation} from '../types/SingleSimulation'

export interface DealerFormSelection {
    dealerSimulation: SingleSimulation
    dealerImageListing: string
    promoIndex: number
}

const DEALER_FORM_SELECTION_STORAGE_KEY = 'fa-flotte-dealer-form-selection'

const isObjectRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null

const isDealerFormSelection = (
    value: unknown
): value is DealerFormSelection => {
    if (!isObjectRecord(value)) {
        return false
    }

    return (
        isObjectRecord(value.dealerSimulation) &&
        typeof value.dealerImageListing === 'string' &&
        typeof value.promoIndex === 'number'
    )
}

export const saveDealerFormSelection = (
    selection: DealerFormSelection
): void => {
    if (typeof window === 'undefined') {
        return
    }

    try {
        window.sessionStorage.setItem(
            DEALER_FORM_SELECTION_STORAGE_KEY,
            JSON.stringify(selection)
        )
    } catch {
        return
    }
}

export const getDealerFormSelection = (): DealerFormSelection | undefined => {
    if (typeof window === 'undefined') {
        return undefined
    }

    try {
        const storedSelection = window.sessionStorage.getItem(
            DEALER_FORM_SELECTION_STORAGE_KEY
        )

        if (!storedSelection) {
            return undefined
        }

        const parsedSelection: unknown = JSON.parse(storedSelection)

        if (!isDealerFormSelection(parsedSelection)) {
            return undefined
        }

        return parsedSelection
    } catch {
        return undefined
    }
}
